import React from "react";

import { TAB_TYPES } from "../constants";

/**
 * Tab Navigation Component
 */
const TabNav = ({ activeTab, onTabChange }) => {
  const tabs = [TAB_TYPES.TEAMS, TAB_TYPES.REFEREES, TAB_TYPES.ADMINISTRATORS];

  return (
    <div className="flex items-center gap-3">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          className={`flex px-4 py-2.5 text-sm hover:text-[#00E7FF] items-center justify-center font-medium capitalize transition-colors relative 
            ${activeTab === tab
              ? "bg-[#001A2A] text-[#00E7FF] rounded-full"
              : "text-app-text-muted hover:text-app-accent"}`
          }
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default TabNav;
